import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.less']
})
export class TooltipComponent implements OnInit {

  @Input() showsTooltip = false;
  @Input() topPosition = 0;
  @Input() leftPosition = 0;
  @Input() row1 = null;
  @Input() row1Label = null;
  @Input() row2 = null;
  @Input() row2Label = null;
  @Input() row3 = null;
  @Input() row3Label = null;

  //  @Input() tooltipRows = null;
  @Input() tooltipText = null;

  constructor() { }

  ngOnInit(): void { }
};